<template>
  <section class="section">
    <div class="section-header">
      <h1>ตรวจสอบผลการลงทะเบียนเรียนและประวัติการยืนยัน</h1>
    </div>
    <div class="section-body">
      <div class="card">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>ค้นหา/แสดงข้อมูล</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">หมายถึงฟิลด์ที่จำเป็น</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >ปีการศึกษา<code
                        style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <select class="form-control">
                      <option selected>2562</option>
                      <option>2563</option>
                      <option>2564</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >ภาคการศึกษา<code
                        style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>1</option>
                        <option>2</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >ระดับการศึกษา
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option>---กรุณาเลือก---</option>
                        <option>0:เรียนบางรายวิชา</option>
                        <option>1:ประกาศนียบัตร</option>
                        <option>2:อนุปริญญา</option>
                        <option selected>3:ปริญญาตรี</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>สำนักวิชา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>10:ศิลปศาสตร์</option>
                        <option>11:วิทยาศาสตร์</option>
                        <option>12:การจัดการ</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>สาขาวิชา</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>ไม่ระบุ1</option>
                        <option>ไม่ระบุ2</option>
                        <option>ไม่ระบุ3</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>หลักสูตร</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="submit"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                            />
                            <button class="btn btn-danger btn-lg" type="submit">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ชั้นปี</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <select class="form-control">
                        <option selected>---ไม่ระบุ---</option>
                        <option>ไม่ระบุ1</option>
                        <option>ไม่ระบุ2</option>
                        <option>ไม่ระบุ3</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ตั้งแต่ รหัสประจำตัว</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="submit"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                            />
                            <button class="btn btn-danger btn-lg" type="submit">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>ถึง รหัสประจำตัว</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                            />
                            <button
                              class="btn btn-primary btn-lg"
                              type="submit"
                            >
                              <i class="fas fa-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                            />
                            <button class="btn btn-danger btn-lg" type="submit">
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button class="btn btn-primary btn-lg">ค้นหา</button
                  >&nbsp;&nbsp;&nbsp;
                  <button class="btn btn-light btn-lg">ล้างหน้าจอ</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <div class="table-responsive">
              <table class="table table-striped" id="table-2">
                <thead>
                  <tr>
                    <th class="text-center"></th>
                    <th class="text-center">ลำดับ</th>
                    <th class="text-center">รหัสประจำตัว</th>
                    <th class="text-center">ชื่อ-นามสกุล</th>
                    <th class="text-center">สาขาวิชา</th>
                    <th class="text-center">ระดับการศึกษา</th>
                    <th class="text-center">หน่วยกิต</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-center">
                      <v-btn text icon @click="goTo(1)">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-center">1</td>
                    <td class="text-danger" style="white-space: nowrap">
                      563 1005 002
                    </td>
                    <td style="white-space: nowrap">
                      MR. JOUNGMIN NOH
                    </td>
                    <td style="white-space: nowrap">ภาษาและวัฒนธรรมไทย</td>
                    <td style="white-space: nowrap">
                      3:ปริญญาตรี ชั้นปี 6
                    </td>
                    <td class="text-center">
                      18
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <v-btn text icon @click="goTo(1)">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-center">2</td>
                    <td class="text-danger" style="white-space: nowrap">
                      603 1005 002
                    </td>
                    <td style="white-space: nowrap">
                      MR. HARAM JEONG
                    </td>
                    <td style="white-space: nowrap">
                      ภาษาและวัฒนธรรมไทยสำหรับชาวต่างประเทศ
                    </td>
                    <td style="white-space: nowrap">
                      3:ปริญญาตรี ชั้นปี 2
                    </td>
                    <td class="text-center">
                      12
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <v-btn text icon @click="goTo(1)">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-center">3</td>
                    <td class="text-danger" style="white-space: nowrap">
                      603 1005 007
                    </td>
                    <td style="white-space: nowrap">
                      MISS LAMAI YU
                    </td>
                    <td style="white-space: nowrap">
                      ภาษาและวัฒนธรรมไทยสำหรับชาวต่างประเทศ
                    </td>
                    <td style="white-space: nowrap">
                      3:ปริญญาตรี ชั้นปี 2
                    </td>
                    <td class="text-center">
                      18
                    </td>
                  </tr>
                  <tr>
                    <td class="text-center">
                      <v-btn text icon @click="goTo(1)">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </td>
                    <td class="text-center">4</td>
                    <td class="text-danger" style="white-space: nowrap">
                      603 1005 008
                    </td>
                    <td style="white-space: nowrap">
                      MR. NAG WUN YONE
                    </td>
                    <td style="white-space: nowrap">
                      ภาษาและวัฒนธรรมไทยสำหรับชาวต่างประเทศ
                    </td>
                    <td style="white-space: nowrap">
                      3:ปริญญาตรี ชั้นปี 2
                    </td>
                    <td class="text-center">
                      9
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "tor11",
  data: () => ({
    selected: 0
  }),
  methods: {
    goTo(index) {
      this.selected = index;
      this.$router.push({ name: "chkResultRegister" });
    }
  }
};
</script>
